var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, ScreenContainer, ContentFrame } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import { useOpts } from '../../context';
import DetailsTable from '../../LinkApiRouter/components/Table/DetailsTable';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import ModalHeader from '../../components/ModalHeader';
import getAmountStringForAllocation from '../../LinkApiRouter/utils/get-amount-string-for-allocation';
import getSelectedBankInfo from '../../utils/dd-forms/get-selected-bank-info';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import FontCard from '../../components/FontCard';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useUserEnteredBankInfo from '../../hooks/useUserEnteredBankInfo';
import { checkHackyWorkspace } from '../../utils/hacky-workspace-customizations';
var ConfirmationScreen = function () {
    var getLocalizedString = useGetLocalizedString();
    var amountSelection = useOpts().amountSelection;
    var _a = useDDFormContext(), goBack = _a.goBack, setIsEditFlow = _a.setIsEditFlow, employerName = _a.employerName, userName = _a.userName, bankInfos = _a.bankInfos, signatureStyle = _a.signatureStyle;
    var navigate = useLinkNavigate();
    var amountText = useMemo(function () { return getAmountStringForAllocation(amountSelection, getLocalizedString); }, [amountSelection, getLocalizedString]);
    var selectedBankInfo = useMemo(function () { return getSelectedBankInfo(bankInfos); }, [bankInfos]);
    var userEnteredBankInfo = useUserEnteredBankInfo();
    var linkTokenPayload = useOpts().linkTokenPayload;
    var workspaceName = linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName;
    var isCitadel = checkHackyWorkspace('Citadel CU', workspaceName) ||
        checkHackyWorkspace('Citadel Theme Testing', workspaceName);
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack }),
        React.createElement(ContentFrame, null,
            React.createElement(TitleFrame, { title: getLocalizedString('DIRECT_DEPOSIT_FORM'), subtitle: getLocalizedString('DD_FORM_REVIEW_AND_GENERATE'), "data-testid": "DDFormConfirmation" },
                React.createElement("div", { className: "details-table", style: {
                        margin: '8px 0',
                        width: '100%',
                    } },
                    React.createElement(DetailsTable, { data: [
                            {
                                label: getLocalizedString('EMPLOYER'),
                                value: employerName,
                            },
                            {
                                label: getLocalizedString('NAME'),
                                value: userName,
                            },
                            {
                                label: getLocalizedString('AMOUNT'),
                                value: amountText,
                            },
                            {
                                label: getLocalizedString('FREQUENCY'),
                                value: getLocalizedString('EVERY_PAYCHECK'),
                            },
                            {
                                label: getLocalizedString('DEPOSIT_TO'),
                                value: selectedBankInfo
                                    ? "".concat(selectedBankInfo.name, " *").concat(selectedBankInfo.accountNumberLastFour)
                                    : (userEnteredBankInfo &&
                                        "".concat(userEnteredBankInfo.accountName, " *").concat(userEnteredBankInfo.accountNumber.slice(-4))) ||
                                        '',
                            },
                        ] })),
                React.createElement(Button, __assign({ variant: "ghost" }, (isCitadel ? { color: 'secondary' } : {}), { dataTestId: "ddForm-edit", onClick: function () {
                        navigate('/dd-form/employer-name-entry');
                        // Start including amount selection step when the user actively chooses to edit the form data
                        setIsEditFlow(true);
                    }, eventId: "DDForm-edit" }), getLocalizedString('EDIT_THIS')),
                React.createElement(FontCard, { "data-testid": "ddForm-signature-card", signatureStyle: signatureStyle, displayText: userName, sx: { marginBottom: '16px' } }),
                React.createElement(Button, __assign({ variant: "ghost" }, (isCitadel ? { color: 'secondary' } : {}), { dataTestId: "ddForm-signature", eventId: "DDForm-editSignature", onClick: function () {
                        navigate('/dd-form/signature-style-selection');
                    } }), getLocalizedString('CHANGE_SIGNATURE_STYLE')),
                React.createElement(Button, { dataTestId: "ddForm-generate", onClick: function () {
                        navigate('/dd-form/document-display');
                    } }, getLocalizedString('GENERATE_FORM'))))));
};
export default ConfirmationScreen;
